import ArtistItem from '@/components/global/artists/item';
import Guest from '@/layouts/guest';
import React, {useEffect, useState} from 'react';
import { Container, Row } from 'react-bootstrap';
import ArtistsService from "@/services/artists-service";
import Loader from "@/components/global/loader";

const Artists: React.FC = () => {
    const title = "آرتیست ها";
    const [artists, setArtists] = useState<IArtistItem[]>([]);
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        ArtistsService.getArtists().then((data : IArtistItem[]) => {
            setArtists(data);
        }).catch((err:any) => {
            console.error(err);
        }).finally(() => {
            setLoading(false);
        });
    }, []);

    return (
        <Guest title={title}>
          <Container className="py-5">
              {loading ? <Loader /> : (
                  <>
                      {artists.length ? (
                          <Row>
                              {artists.map((artist, index) => (
                                  <div key={'artist' + artist.id + Math.random()} className="col-lg-4 col-sm-6 mx-auto mb-4" style={{ maxWidth: '300px' }}>
                                      <ArtistItem artist={artist} />
                                  </div>
                              ))}
                          </Row>
                      ) : (
                          <h5 className="text-danger">موردی یافت نشد!</h5>
                      )}
                  </>
              )}
          </Container>
        </Guest>
    );
}

export default Artists;
